var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog", class: { active: _vm.showDialog } },
    [
      _c(
        "div",
        {
          staticClass:
            "dialog--content u-extra-medium-padding--bottom c-employee-modal",
        },
        [
          _c("h4", { staticClass: "u-extra-small-margin--bottom" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("kolonne.vehicle.title.modal")) +
                "\n\n      "
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
              },
              [
                _c(
                  "div",
                  { staticClass: "loading-spinner-wrapper" },
                  [
                    _c("PageLoading", {
                      attrs: { position: "absolute", right: "" },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "h5",
            { staticClass: "u-color--primary u-extra-medium-margin--bottom" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("kolonne.title")) +
                  " " +
                  _vm._s(_vm.selectedKolonneNumber) +
                  "\n      "
              ),
              _vm.week ? [_vm._v(" — KW " + _vm._s(_vm.week))] : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.selectedKolonneNumber == "" || _vm.selectedKolonneNumber == null
            ? _c("p", { staticClass: "is-error" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("kolonne.error.nokolonne")) +
                    "\n    "
                ),
              ])
            : _c(
                "div",
                [
                  _vm.saveVehiclesError
                    ? _c("div", { staticClass: "grid-container fluid" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "grid-x grid-margin-x align-center align-middle",
                          },
                          [
                            _c("div", { staticClass: "cell small" }, [
                              _c(
                                "div",
                                { staticClass: "callout alert text-center" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("kolonne.vehicle.saveerror")
                                      ) +
                                      ": " +
                                      _vm._s(_vm.saveVehiclesError.message) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-x grid-margin-x" }, [
                    _c("div", { staticClass: "cell small-6" }, [
                      _c(
                        "h6",
                        {
                          staticClass:
                            "u-color--dark-gray u-no-margin--bottom u-extra-small-padding--bottom",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("kolonne.vehicle.selected")) +
                              " (" +
                              _vm._s(_vm.selectedVehicles.length) +
                              ")\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.selectedVehicles.length === 0
                        ? _c("p", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("kolonne.vehicle.novehicles.selected")
                                ) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell small-6 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button u-text-small",
                          on: { click: _vm.onSaveVehicles },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("save")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.selectedVehicles, function (vehicle) {
                    return _c("KolonneSettingsVehiclesListItem", {
                      key: `selected-${vehicle.id}`,
                      attrs: {
                        active: true,
                        vehicle: vehicle,
                        startdate: _vm.startdate,
                        "kolonne-content": _vm.kolonneContent,
                        "hide-ranking": true,
                      },
                      on: { activeChanged: _vm.onChangeVehicleSelected },
                    })
                  }),
                  _vm._v(" "),
                  this.availableVehicles.length === 0
                    ? _c(
                        "p",
                        { staticClass: "u-color--alert text-center h6" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("kolonne.message.novehicles")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        [
                          _vm.refreshingDataError
                            ? _c(
                                "div",
                                { staticClass: "grid-container fluid" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x align-center align-middle",
                                    },
                                    [
                                      _c("div", { staticClass: "cell small" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "callout alert text-center",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "kolonne.vehicle.refresherror"
                                                  )
                                                ) +
                                                ": " +
                                                _vm._s(
                                                  _vm.refreshingDataError
                                                    .message
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "grid-x grid-margin-x align-middle u-extra-medium-padding--top",
                            },
                            [
                              _c("div", { staticClass: "cell small-6" }, [
                                _c(
                                  "h6",
                                  {
                                    staticClass:
                                      "u-color--dark-gray u-no-margin--bottom",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("kolonne.vehicle.available")
                                        ) +
                                        " (" +
                                        _vm._s(_vm.availableVehicles.length) +
                                        ")\n            "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "cell small-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "grid-x grid-margin-x align-middle",
                                  },
                                  [
                                    _c("div", { staticClass: "cell auto" }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cell small-2 text-right",
                                      },
                                      [
                                        _vm.isRefreshingData
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "loading-spinner-wrapper",
                                              },
                                              [
                                                _c("PageLoading", {
                                                  staticClass:
                                                    "loading-spinner--small u-no-margin",
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "cell shrink text-right" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button button--small outline secondary",
                                            class: {
                                              disabled: _vm.isRefreshingData,
                                            },
                                            on: {
                                              click: _vm.onRefreshVehicleData,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "kolonne.settings.data.refresh"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "u-text-medium u-extra-small-margin--bottom u-extra-small-margin--top",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "kolonne.vehicle.source.geocapture.hint"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "grid-x grid-margin-x align-middle",
                            },
                            [
                              _c("div", { staticClass: "cell small-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--search u-extra-small-margin--bottom",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.vehicleSearchtext,
                                          expression: "vehicleSearchtext",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control--small form-control--search",
                                      attrs: {
                                        type: "text",
                                        name: "vehiclefilter",
                                        placeholder: _vm.$t("search"),
                                      },
                                      domProps: {
                                        value: _vm.vehicleSearchtext,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.vehicleSearchtext =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("KolonneSettingsVehiclesRankingLegend", {
                            staticClass: "u-extra-medium-margin--bottom",
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "grid-x grid-margin-x align-middle",
                            },
                            _vm._l(_vm.filteredVehicles, function (vehicle) {
                              return _c("KolonneSettingsVehiclesListItem", {
                                key: vehicle.id,
                                attrs: {
                                  active: _vm.isSelectedVehicle(vehicle),
                                  vehicle: vehicle,
                                  startdate: _vm.startdate,
                                  "kolonne-content": _vm.kolonneContent,
                                  "selected-kolonne-id": _vm.selectedKolonneId,
                                },
                                on: {
                                  activeChanged: _vm.onChangeVehicleSelected,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                ],
                2
              ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCloseDialog.apply(null, arguments)
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }